export const RESET_SURVEY_DATA = 'RESET_SURVEY_DATA';
export const FETCH_SURVEY_REQUEST = 'FETCH_SURVEY_REQUEST';
export const FETCH_SURVEY_SUCCESS = 'FETCH_SURVEY_SUCCESS';
export const FETCH_SURVEY_FAILURE = 'FETCH_SURVEY_FAILURE';

export const POST_SURVEY_REQUEST = 'POST_SURVEY_REQUEST';
export const POST_SURVEY_SUCCESS = 'POST_SURVEY_SUCCESS';
export const POST_SURVEY_FAILURE = 'POST_SURVEY_FAILURE';
